module.exports = __webpack_public_path__ + "static/media/Frame.5637d0a5.svg";